module.exports = __webpack_public_path__ + "static/media/task.3098b1af.svg";